import LsLogoSVG from "@design-system/ui-icons/vanilla/LsLogo"
import { createIcon } from "../createIcon"

export const LsLogoIcon = createIcon(LsLogoSVG)
